module.exports = __webpack_public_path__ + "img/button-dark.eb6abd35.svg";